import React from 'react';
import styles from './CalendarSettingsContent.module.scss';
import clx from 'classnames';
import { useDispatch } from 'react-redux';
import { modalActions } from '../../../../../Modals/store';
import { useTranslation } from 'react-i18next';
import { ChevronRight, DoorClosed, DoorOpen } from 'lucide-react';

const CalendarSettingsContent = ({
  startDay,
  searchParams,
  variant = 'dropdown',
  onAction,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const showExtraActions = !(
    localStorage.getItem('staff') && searchParams?.get('allowInsert') != 1
  );

  const openModal = (type) => {
    onAction?.();
    dispatch(
      modalActions.OPEN_MODAL.SUCCESS({
        type,
        props: { startDay },
      }),
    );
  };

  if (!showExtraActions) return null;

  return (
    <div
      className={clx(styles.settings_content, {
        [styles.settings_content_modal]: variant === 'modal',
      })}
    >
      <div className={styles.section_label}>{t('scheduler.calendarHeader.extra')}</div>
      <div className={styles.actions_list}>
        <button
          type="button"
          className={styles.settings_action}
          onClick={() => openModal('workerExtraWorkingTimeOneDayModal')}
        >
          <span className={styles.settings_action_icon} aria-hidden>
            <DoorOpen size={18} strokeWidth={2.2} />
          </span>
          <span className={styles.settings_action_copy}>
            <span className={styles.settings_action_title}>
              {t('scheduler.calendarHeaderModal.extraOpening')}
            </span>
          </span>
          <ChevronRight
            className={styles.settings_action_chevron}
            size={16}
            strokeWidth={2.4}
            aria-hidden
          />
        </button>
        <button
          type="button"
          className={styles.settings_action}
          onClick={() => openModal('workerClosuresOneDayModal')}
        >
          <span className={styles.settings_action_icon} aria-hidden>
            <DoorClosed size={18} strokeWidth={2.2} />
          </span>
          <span className={styles.settings_action_copy}>
            <span className={styles.settings_action_title}>
              {t('scheduler.calendarHeaderModal.extraClosing')}
            </span>
          </span>
          <ChevronRight
            className={styles.settings_action_chevron}
            size={16}
            strokeWidth={2.4}
            aria-hidden
          />
        </button>
      </div>
    </div>
  );
};

export default CalendarSettingsContent;
